module.exports = __webpack_public_path__ + "static/media/teal-logo-text.d4a62975.svg";